import { useState, useEffect, useCallback, useRef } from 'react';

export function useFetch(fetcher, deps = []) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const mounted = useRef(true);

    useEffect(() => {
        mounted.current = true;
        return () => { mounted.current = false; };
    }, []);

    const run = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const { data: d } = await fetcher();
            if (mounted.current) setData(d);
        } catch (err) {
            if (mounted.current)
                setError(err.response?.data?.error || err.message || 'Something went wrong');
        } finally {
            if (mounted.current) setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    useEffect(() => { run(); }, [run]);
    return { data, loading, error, refetch: run };
}
